export const cartServiceInitialState = {
  loaders: Object.create(null),
  itemInEdit: undefined,
};
